import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { FaThumbsUp } from "react-icons/fa";
import {
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowUp,
} from "react-icons/md";
import clientConfig from "../../env";
import { useSelector } from "react-redux";

const DUMMY_EVENTS = [
  {
    name: "Scaling Business Operations Efficiently",
    voted: 25,
  },
  {
    name: "Leveraging AI for Business Growth",
    voted: 19,
  },
  {
    name: "Building a Strong Company Culture",
    voted: 12,
  },
  {
    name: "New Client Acquisition and Retention Strategies",
    voted: 9,
  },
  {
    name: "Adapting to Market Changes",
    voted: 0,
  },
  {
    name: "The Power of Storytelling in Business",
    voted: 0,
  },
  {
    name: "Crafting a Unique Value Proposition",
    voted: 0,
  },
  {
    name: "Managing Remote Teams Effectively",
    voted: 0,
  },
  {
    name: "Negotiation Tactics for Business Success",
    voted: 0,
  },
  {
    name: "Implementing Effective Crisis Management Plans",
    voted: 0,
  },
  {
    name: "Creating Passive Income Streams for Your Business",
    voted: 0,
  },
  {
    name: "Developing Long-Term Client Relationships",
    voted: 0,
  },
];

export const getNextWeekEventList = async(userId) => {
  const headers = {
    "Content-Type": "application/json",
  };
  return await axios.get(
    `${clientConfig.siteUrl}wl/v1/getAllNextWeekEvents/${userId}`,
    { headers: headers }
  );
}

function EventList() {

  const userId = useSelector((state) => state.user.userId);
  const { topics } = useSelector( (state) => state.events)

  const [isLoading, setIsLoading] = useState(false);
  const [allEventList, setAllEventList] = useState(topics || []);
  const [evnentList, setEventList] = useState(topics || []);
  const [seeMoreTopic, setSeeMoreTopic] = useState(false);
  const [votedId, setVotedId] = useState(null);

  const firstFiveEvents = useCallback(
    (eventList) => {
      if ((eventList && eventList?.length) || allEventList?.length) {
        const allEvents = allEventList || eventList;
        if (allEvents.length > 5) {
          const events = [];
          for (let i = 0; i < 5; i++) {
            events.push(allEvents[i]);
          }
          setEventList(events);
        } else {
          setEventList(allEvents);
        }
      } else {
        setEventList([]);
      }
    },
    [allEventList]
  );

  const handleSeeMoreTopics = () => {
    setSeeMoreTopic((prev) => !prev);
  };
  const getAllNextWeekTopics = async () => {
    try {
      setIsLoading(true);
      const response = await getNextWeekEventList(userId);
      if (response.data?.topics?.length) {
        setAllEventList(response?.data?.topics);
      } else {
        setAllEventList([]);
      }
      if (response?.data?.voted_topic_id) {
        setVotedId(response.data.voted_topic_id);
      } else {
        setVotedId(null);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdateVotes = async(event,data) => {
    event.preventDefault();
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const response = await axios.post(
        `${clientConfig.siteUrl}wl/v1/addOrRemoveVoteForEvent`,
        data,
        { headers: headers }
      );

      console.log(response)
      if (response.data?.topics?.length) {
        setAllEventList(response?.data?.topics);
      } else {
        setAllEventList([]);
      }

      if (response?.data?.voted_topic_id) {
        setVotedId(response.data.voted_topic_id);
      } else {
        setVotedId(null);
      }
    } catch(error) {
      console.error(error);
    }
  }

  const enabledVoteBtn = (topicId) => {
    if (votedId === null || votedId === parseInt(topicId)) {
      return false;
    } else {
      return true;
    }
  }

  useEffect(() => {
    getAllNextWeekTopics();
  }, []);

  useEffect(() => {
    if (seeMoreTopic) {
      setEventList(allEventList);
    } else {
      firstFiveEvents();
    }
  }, [seeMoreTopic, firstFiveEvents, allEventList]);

  useEffect( () => {
    setAllEventList(topics)
    console.log(topics)
  }, [topics])

  const EventListContainer = (props) => {
    return (
      <div className="events-border rounded py-3 px-4">
        <h3 className="mb-0">Vote for Next Week's Event</h3>
        <p className="mb-4 font-weight-bold">
          When the event ends, the new popular topic get scheduled. Tuesday @
          10:00 AM EST.
        </p>
        {props.children}
      </div>
    )
  }

  if (isLoading) {
    return (
      <EventListContainer>
        <p>Loading...</p>
      </EventListContainer>
    );
  }

  if (evnentList?.length === 0) {
    return (
      <EventListContainer>
        <p>No Event Topics.</p>
      </EventListContainer>
    );
  }

  return (
    <EventListContainer>
      <ul className="p-0 m-0">
        {evnentList.map((event) => (
          <li
            key={event.topic_id}
            className="d-flex justify-content-between align-items-center mb-2 text-left"
          >
            <p className="m-0">{event.topic_name}</p>
            <div className="d-flex justify-content-between align-items-center">
              <span className="mr-2">{event.votes} voted</span>
              <button
                style={
                  enabledVoteBtn(event.topic_id)
                    ? { cursor: "not-allowed" }
                    : {}
                }
                className={`btn py-1 px-1 d-flex align-items-center ${
                  enabledVoteBtn(event.topic_id) ? "disabled" : ""
                }  ${event.has_voted ? "btn-primary" : "btn-secondary"}`}
                onClick={(e) =>
                  handleUpdateVotes(e, {
                    topic_id: parseInt(event.topic_id),
                    user_id: userId,
                    voteAction: event.has_voted ? "downVote" : "upVote",
                    votes: event.votes,
                  })
                }
                disabled={enabledVoteBtn(event.topic_id)}
              >
                <FaThumbsUp className="text-white" size={13} />
              </button>
            </div>
          </li>
        ))}
      </ul>
      {allEventList?.length > 5 && (
        <div className="mt-3 text-left">
          {!seeMoreTopic ? (
            <p
              className="text-left font-weight-bold m-0 d-inline-block btn p-0"
              onClick={handleSeeMoreTopics}
            >
              See More Topics <MdOutlineKeyboardArrowDown size={20} />
            </p>
          ) : (
            <p
              className="text-left font-weight-bold m-0 d-inline-block btn p-0"
              onClick={handleSeeMoreTopics}
            >
              See Less Topics <MdOutlineKeyboardArrowUp size={14} />
            </p>
          )}
        </div>
      )}
    </EventListContainer>
  );
}

export default EventList;
